<script>
	import { onMount } from 'svelte'
	import { addressSchema } from './address-schema'
	import page from 'page'
	import CardForm from './CardForm.svelte'
	import AddressForm from './AddressForm.svelte'

	import { orderId, orderInfo } from './store'
	import db from './firebase'
	import { get } from 'svelte/store';

	export let card = {};
	export let fromAddress = {};
	export let toAddress = {};

	onMount(async () => {
		let savedInfo = await get(orderInfo);
		card = Object.assign({}, savedInfo.card);
		fromAddress = Object.assign({}, savedInfo.fromAddress);
		toAddress = Object.assign({}, savedInfo.toAddress);
	});

	let validFrom = true;
	let validTo = true;
	let validCard = true;
	
	const submitInfo = async () => {
		validFrom = await addressSchema.isValid(fromAddress);
		validTo = await addressSchema.isValid(toAddress);
		validCard = card.header && card.content;
		if (validFrom && validTo && validCard) {
			let cardInfo = {
				card: card,
				fromAddress: fromAddress,
				toAddress: toAddress
			};
			orderInfo.set(cardInfo);
			//add to firestore here
			db.collection('orders').add(cardInfo).then(ref => {
				orderId.set(ref.id);
				page('/checkout');
			});
		}
	};
</script>

<main>
	<div class="font-bold text-2xl md:text-4xl my-6 py-6 px-6">
		Write a message and we'll send it anywhere in the US.
	</div>
	<div>
		<CardForm bind:card/>
	</div>
	{#if !validCard}
		<div class="pt-4 px-6 text-lg text-red-800">
			Enter card information.
		</div>
	{/if}
	<div class="text-3xl my-1 md:my-3 md:my-6 pt-10">
		Tell us who it's from.
	</div>
	<AddressForm header={"Sender's"} bind:address={fromAddress}/>
	<div class="text-3xl my-1 md:my-3 md:my-6">
		Tell us where it's going.
	</div>
	<AddressForm header={"Recipient's"} bind:address={toAddress}/>
	{#if !validFrom || !validTo}
		<div class="md:pt-4 px-6 text-lg text-red-800">
			Please make sure your addresses include all necessary information.
		</div>
	{/if}
	<div class="w-1/3 mx-auto">
		<button on:click={submitInfo} class="w-full md:w-1/2 my-6 py sm:text-md md:text-3xl text-white font-bold bg-purple-700 hover:bg-purple-600 focus:outline-none border-b-4 border-blue-900 rounded-lg">Continue</button>
	</div>
</main>

<style>
    
</style>